var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "racing-iframe-wrap" }, [
    _c("iframe", {
      ref: "racingiframeelm",
      staticClass: "racing-iframe",
      attrs: { src: _vm.racingIframeSrc, scrolling: "no", frameborder: "0" },
      on: { load: _vm.iframeLoaded }
    }),
    _vm._v(" "),
    _c("div", { ref: "racingiframeremoteelm", staticClass: "test-ctrls off" }, [
      _c("button", { staticClass: "btn8", on: { click: _vm.iframeLoaded } }, [
        _vm._v("init")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessage4Home()
            }
          }
        },
        [_vm._v("home")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessageToRacingIFrame("login")
            }
          }
        },
        [_vm._v("login")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessage4Logout()
            }
          }
        },
        [_vm._v("logout")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessage4Geolocation()
            }
          }
        },
        [_vm._v("geolocation")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessage4ChangePage()
            }
          }
        },
        [_vm._v("changePage")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn8",
          on: {
            click: function($event) {
              return _vm.sendMessage4DisplayControl()
            }
          }
        },
        [_vm._v("displayControl")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-492f6e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492f6e84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/externalintegrations/racing/RacingIframe.vue
// module id = null
// module chunks = 